import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo los tomos después de comprar?',
    a: 'En el momento del pago recibís un mail con el link de descarga. Acceso inmediato, sin esperas. Si no llega, revisá spam o escribinos a soportenichodigital@gmail.com'
  }, {
    q: '¿Funciona si nunca cociné absolutamente nada?',
    a: 'Exactamente para eso está diseñado. Arrancás desde el principio absoluto: qué utensilio usar, cómo encender el fuego, cuánto tiempo dejar algo en la sartén. No se asume ningún conocimiento previo.'
  }, {
    q: '¿Necesito ingredientes caros o raros?',
    a: "No. Todo el sistema está pensado para ingredientes del supermercado de barrio, a precio normal. El Tomo 4 'Sin un Mango' está dedicado exactamente a eso."
  }, {
    q: '¿En cuánto tiempo veo resultados reales?',
    a: 'En un fin de semana tenés las bases. Si arrancás con el Tomo 1 y el Tomo 3 el sábado, el lunes ya cocinás diferente. Eso no es marketing: es la estructura del sistema.'
  }, {
    q: '¿Qué diferencia tiene con recetas de YouTube?',
    a: 'Los videos de YouTube son recetas sueltas sin progresión ni estructura. Esto es un sistema en tomos: cada uno tiene un propósito claro y van de menos a más. No buscás más, no improvisás.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días desde la compra. Si abrís los tomos y no es lo que esperabas, mandás un mail a soportenichodigital@gmail.com y te devolvemos el 100% sin preguntas. Nuestros números hablan solos: menos del 1% de devoluciones.'
  }];
  return <section className="py-10 md:py-20" data-id="element-71">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-73">
          <h2 className="text-2xl md:text-5xl font-serif font-bold text-white" data-id="element-74">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-75">
          {faqs.map((faq, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} key={i} className="bg-brand-panel rounded-xl border border-brand-border overflow-hidden" data-id="element-76">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none" data-id="element-77">
                <h3 className="text-base md:text-xl font-bold text-white pr-4" data-id="element-78">
                  {faq.q}
                </h3>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0" data-id="element-79">
                  <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-brand-gold" data-id="element-80" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-81">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-82">
                    <div className="px-4 md:px-6 pb-4 md:pb-6 pt-0" data-id="element-83">
                      <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-84">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}